export const messages = {
  es: [
    {
      code: 500,
      title: 'HA OCURRIDO UN ERROR',
      text: 'Por favor vuelva a intentar de nuevo, si el problema continua comuniquese con nosotros.'
    },
    {
      code: 404,
      title: 'ELEMENTO NO ENCONTRADO',
      text: 'La consulta realizada no ha devuelto resultados, por favor revise el o los campos ingresados.'
    },
    {
      code: 403,
      title: 'NO TIENE PERMISOS',
      text: 'La información solicitada no esta disponible debido a que no cuenta con los permisos suficientes para acceder.'
    },
    {
      code: 401,
      title: 'ACCESO NO AUTORIZADO',
      text: 'Para poder acceder a este contenido debe de iniciar sesión, si no se ha registrado puede hacerlo.'
    },
    {
      code: 409,
      title: 'SOLICITUD DENEGADA',
      text: 'Este elemento no se puede borrar debido a que esta asociado a otros elementos o información relevante del sistema'
    },
    {
      code: 999,
      title: 'ERROR DESCONOCIDO',
      text: 'Ha ocurrido un error desconocido, por favor intente de nuevo'
    },
    {
      code: 415,
      title: 'FORMATO NO VALIDO',
      text: 'El formato del elemento no es permitido para la acción que esta realizando'
    }
  ],
  en: [
    {
      code: 500,
      title: 'AN ERROR HAS OCCURRED',
      text: 'Por favor vuelva a intentar de nuevo, si el problema continua comuniquese con nosotros.'
    },
    {
      code: 404,
      title: 'ELEMENT NOT FOUND',
      text: 'La consulta realizada no ha devuelto resultados, por favor revise el o los campos ingresados.'
    },
    {
      code: 403,
      title: 'YOU HAVE NO ACCESS',
      text: 'La información solicitada no esta disponible debido a que no cuenta con los permisos suficientes para acceder.'
    },
    {
      code: 401,
      title: 'PLEASE LOG IN',
      text: 'Para poder acceder a este contenido debe de iniciar sesión, si no se ha registrado puede hacerlo.'
    },
    {
      code: 409,
      title: 'REQUEST IN PROGRESS',
      text: 'Ya cuenta con una solicitud en proceso, solo puede tener una solicitud de crédito abierta a la vez.'
    },
    {
      code: 999,
      title: 'UNKNOWN ERROR',
      text: 'An unknown error has ocurred, please try again.'
    },
    {
      code: 415,
      title: 'FORMATO NO VALIDO',
      text: 'El formato del elemento no es permitido para la acción que esta realizando'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/core/locale/translation/http_requests.js